import styled from 'styled-components';
import { CaptionRegularL } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ILegendText {
  theme: ITheme;
  isExpanded: boolean;
}

export const LegendCont = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.centy} ${theme.layout.spacing.centy};
    padding: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.mili};

    [data-testid="linkCont"] {
      margin-top: ${theme.layout.spacing.centy};
    }
  `}
`;

export const LegendText = styled(CaptionRegularL)<ILegendText>`
  flex: 1;
  margin-right: 100px;

  ${({ theme, isExpanded }: ILegendText) => `
    color: ${theme.colors.neutral.primary[80]};
    ${
  !isExpanded
    ? `overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;`
    : null
}
  `}
`;

export const GroupCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    display: flex;
    margin: 0 ${theme.layout.spacing.centy};
    padding: ${theme.layout.spacing.decy};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
  `}
`;
